<template>
  <div :class="['timeLine mb-2', timelineloading ? 'loading' : '', fillHeight ? 'fill' : '']">
    <div class="content flex mb-2" :style="fillHeight ? {} : { height: contentHeight() }" @scroll="onScroll">
      <el-timeline :reverse="false" v-loading="timelineloading">
        <el-timeline-item v-for="(item, index) in activities" :key="index"
          v-bind:class="{ lastItem: index == activities.length - 1 }">
          <div>
            <span :class="item.model == 5 ? 'text' : ''">
              Ship Vetting
            </span>
            <span>
              <!-- {{
                item.logType == 0
                    ? ""
                    : item.logType == 1
                        ? "Pending Logistics"
                        : item.logType == 2
                            ? "Pending Inspector"
                            : item.logType == 3
                                ? "Inspector Responded"
                                : item.logType == 4
                                    ? "Anchorage Inspection"
                                    : item.logType == 5
                                        ? "Rejected"
                                        : item.logType == 6
                                            ? "Accepted"
                                            : item.logType == 7
                                                ? "Pending Observation"
                                                : item.logType == 8
                                                    ? "More Information Required"
                                                    : item.logType == 9
                                                        ? "Customer Uploaded Document"
                                                        : ""
              }} -->
              {{ getShipVettingLogType(item.logType) }}
            </span>
            <p class="timestamp">
              <span>{{ item.createTime ? item.createTime : "" }}
                <template v-if="item.logType !== 9">
                  <span style="color: #a1a6b5"> by</span> {{ item.createBy }}
                </template>
              </span>
            </p>
          </div>
          <el-divider v-show="item.subs"></el-divider>
          <!-- <div v-if="item.model == 5">
            <span v-for="(i, index) in item.subs" :key="index">
              <p class="actionDev text-xs" v-show="i.fname">
                <span style="color: #a1a6b5"> {{ i.fname }}</span> :
                <span v-if="i.oldValue && i.oldValue.length > 0"> Changed from </span>
                <span v-if="i.oldValue && i.oldValue.length > 0"
                      class="primayColor">{{ i.oldValue ? i.oldValue : "Empty" }}</span>
                <span v-if="i.oldValue && i.oldValue.length > 0"> to </span>
                <span class="primayColor">{{ i.targetValue }}</span>
              </p>
            </span>
          </div> -->
          <div v-if="item.logType">
            <span v-for="(i, index) in item.subs" :key="index">
              <p class="actionDev text-xs" v-show="i.fname">
                <span style="color: #a1a6b5"> {{ i.fname }}</span> :
                <span v-if="i.oldValue && i.oldValue.length > 0"> Changed from </span>
                <span
                  v-if="(i.fname === 'shipStatus' || i.fname.includes('Status') || i.fname.includes('status')) && i.oldValue && i.oldValue.length > 0"
                  class="primayColor">
                  {{ getShipVettingStatus(i.oldValue) }}
                </span>
                <span v-else-if="i.oldValue && i.oldValue.length > 0" class="primayColor">
                  {{ i.oldValue ? i.oldValue : "Empty" }}
                </span>
                <span v-if="i.oldValue && i.oldValue.length > 0"> to </span>
                <span v-if="(i.fname === 'shipStatus' || i.fname.includes('Status') || i.fname.includes('status'))"
                  class="primayColor">
                  {{ getShipVettingStatus(i.targetValue) }}
                </span>
                <span v-else class="primayColor">
                  {{ i.targetValue ? i.targetValue : "Empty" }}
                </span>
              </p>
            </span>
          </div>
          <!-- <div v-else>
            <span v-for="(i, index) in item.subs" :key="index">
              <p v-if="i.fname == 'Block'" class="text-xs">
                <span style="color: #a1a6b5"> {{ i.fname }}</span> :
                <span v-if="i.oldValue && i.oldValue.length > 0"> Changed from </span>
                <span v-if="i.oldValue && i.oldValue.length > 0" class="primayColor">{{
                    i.oldValue == 1 ? 'Blocked' : 'Not Blocked'
                  }}</span>
                <span v-if="i.oldValue && i.oldValue.length > 0"> to </span>
                <span class="primayColor">{{ i.targetValue == 1 ? 'Blocked' : 'Not Blocked' }}</span>
              </p>
              <p v-else class="actionDev text-xs" v-show="i.fname">
                <span style="color: #a1a6b5"> {{ i.fname }}</span> :
                <span v-if="i.oldValue && i.oldValue.length > 0"> Changed from </span>
                <span v-if="i.oldValue && i.oldValue.length > 0"
                      class="primayColor">{{ i.oldValue ? i.oldValue : "Empty" }}</span>
                <span v-if="i.oldValue && i.oldValue.length > 0"> to </span>
                <span class="primayColor">{{ i.targetValue ? i.targetValue : "Empty" }}</span>
              </p>
            </span>
          </div> -->
        </el-timeline-item>
        <div class="py-5 text-center" v-if="!noLog">
          <i v-if="loading" class="el-icon-refresh rotating"></i>
          <span v-else class="cursor-pointer text-xs primayColor" @click="loadMore">Load More</span>
        </div>
        <div class="py-5 text-center" v-if="noLog">
          <span class="text-xs">No history record</span>
        </div>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import { getShipVettingHistoryTimeline, getShipVettingLog } from "@/services";
import { getShipVettingStatus, getShipVettingLogType } from "@/utils/constants";
import { mapState } from "vuex";
export default {
  name: "ShipVettingTimeline",
  props: {
    rid: {
      default: null,
    },
    requestData: {
      default: null,
    },
    fillHeight: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      activities: [],
      collection: [],
      Subs: [],
      timelineloading: true,
      loading: false,
      preScrollTop: 0,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      noLog: false,
    };
  },
  computed: {
    ...mapState(["userInfo", "screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    }
  },
  created() {
    this.getlist();
  },
  watch: {
    rid: {
      immediate: true,
      handler() {
        this.getlist();
      },
    },
    requestData: {
      immediate: true,
      handler() {
        this.getlist();
      },
    },
  },
  methods: {
    getShipVettingStatus,
    getShipVettingLogType,
    onScroll(event) {
      let scroll = event.target.scrollTop
      let height = event.target.scrollHeight

      if (this.isIncrease(scroll) && this.hitTarget(scroll, height)) {
        this.loadMore()
      }
    },
    isIncrease(scroll) {
      let increasing = scroll > this.preScrollTop
      this.preScrollTop = scroll
      return increasing
    },
    hitTarget(scroll, height) {
      let target = height * 0.75
      return scroll > target
    },

    contentHeight() {
      return this.userInfo.role == 4 || this.userInfo.role == 5 || this.userInfo.role == 13 ? "calc(99vh - 206px)" : this.isMobileScreen ? "calc(60vh - 200px)" :"calc(48vh - 200px)";
    },
    loadMore() {
      this.getlist()
    },
    getlist() {
      if (this.rid) {
        if (!this.loading) {
          this.loading = true;
          if (this.userInfo.role == 4 || this.userInfo.role == 5) {
            getShipVettingLog(this.rid).then((res) => {
              if (res.code == 200 && res.total != 0) {
                this.timelineloading = false;
                if (res.data && res.data.length) {
                  this.total = res.total;

                  this.activities = [...this.activities, ...this.collectData(res.data)];
                  this.updatePageNum();
                }
              } else {
                this.timelineloading = false;
                this.loading = false;
                this.noLog = true;
              }
              this.loading = false;
            });
          } else {
            getShipVettingHistoryTimeline(this.rid, this.pageNum, this.pageSize).then((res) => {
              if (res.code == 200 && res.total != 0) {
                this.timelineloading = false;
                if (res.rows && res.rows.length) {
                  this.total = res.total;

                  // Append new data to activities instead of overwriting
                  this.activities = [...this.activities, ...this.collectData(res.rows)];
                  this.updatePageNum();
                }
              } else {
                this.timelineloading = false;
                this.loading = false;
                this.noLog = true;
              }
              this.loading = false;
            });
          }
        }
      } else {
        this.timelineloading = false;
      }
    },
    collectData(rows) {
      let data = []
      rows.map(item => {
        if (!this.collection.includes(item.id)) {
          this.collection.push(item.id)
          data.push(item)
        }
      })
      return data
    },

    updatePageNum() {
      if (this.total >= (this.pageNum * this.pageSize)) {
        this.pageNum++
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.timeLine {
  background: #ffffff;
  width: 100%;

  .head {
    font-weight: 750;
    // height: 45px;
    padding: 15px 22px 14px 22px;
    border-bottom: 2px solid #d7d9e1;
    color: #909399;
    font-size: 12px;
  }

  .content {
    padding: 40px 20px;
    // height: calc(432px - 56.5px);
    overflow-y: scroll;
  }

  .text {
    color: red;
  }
}

/* opt-in: fill the parent's height instead of a fixed vh, so the card flexes with the window */
.timeLine.fill {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.timeLine.fill .content {
  flex: 1 1 0;
  min-height: 0;
}

.lastItem ::v-deep .el-timeline-item__tail {
  display: none;
}

.loading .content {
  overflow: hidden;
}

::v-deep .el-timeline-item__node {
  background: $primaryColor;
}

::v-deep .el-timeline-item__tail {
  border-color: $primaryColor;
}

::v-deep .el-timeline-item__content {
  font-size: 14px;

  color: #82889c;
}

.timestamp {
  font-size: 12px;
  color: #82889c;
}

::v-deep .el-divider--horizontal {
  margin: 8px 0;
}

::v-deep .el-timeline {
  height: 40%;
}
</style>
